export default __webpack_public_path__ + "static/media/Icon awesome-telegram.2da49637.svg";